<template>
    <modal name="markdown-modal-dialog" transition="pop-out" width="100%" height="100%" :scrollable="true"
           @opened="whenOpened">
        <loading :active.sync="isLoading" :can-cancel="true" :on-cancel="onCancel" :is-full-page="fullPage"></loading>
        <div slot="top-right">
            <button class="x-button" @click="$modal.hide('markdown-modal-dialog')">
                ❌
            </button>
        </div>
        <b-row no-gutters class="h-100">
            <!--            <b-col>-->
            <!--                &lt;!&ndash; full toolbar: clean redo undo | bold italic strikethrough heading | image link | numlist bullist code quote | preview fullscreen&ndash;&gt;-->
            <!--                <markdown-editor-->
            <!--                        toolbar="clean redo undo | bold italic strikethrough heading | image link | numlist bullist code quote"-->
            <!--                        height="auto" :options="options" v-model="value"-->
            <!--                        @input="updateValue"></markdown-editor>-->
            <!--            </b-col>-->
            <!--            <div class="vl"></div>-->
            <!--            <b-col>-->
            <!--                <div class="markdown-output" v-html="compiledMarkdown"></div>-->
            <!--            </b-col>-->
            <b-col></b-col>
        </b-row>
    </modal>
</template>
<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import marked from 'marked'
    import _ from 'lodash'
    import 'v-markdown-editor/dist/v-markdown-editor.css';
    // import markupPresentation from "./../data/markup-presentation";

    export default {
        name: 'MarkdownModalDialog',
        // props: {
        //     name: String,
        // },
        components: {
            Loading
        },
        created: function () {
        },
        data() {
            return {
                isLoading: true,
                fullPage: false,
                title: '...',
                src: "#",
                backgroundColor: "white",
                videoContent: null,
                titleContentImages: null,
                tagContent: null,
                iframeContent: null,
                input: "",
                value: 'Hello **Markdown** writer!',
                options: {
                    lineNumbers: true,
                    styleActiveLine: true,
                    styleSelectedText: true,
                    lineWrapping: true,
                    indentWithTabs: true,
                    theme: "outline-secondary"
                    // tabSize: 2,
                    // indentUnit: 2
                }
            }
        },
        methods: {
            /*
            beforeOpen(event) {
                try {
                    this.title = event.params.title;
                    this.name = event.params.name;
                    // var initialMarkupContent = "# Navodila \nNa tem mestu podajamo kratka navodila.\n# Video predstavitev\nVsebina video predstavitve.\n# Demo račun\nVsebina demo računa.\n# Kreiranje računa\nVsebina kreiranja računa.\n# Namestitev v lastnem okolju\nVsebina namestitve v lastnem okolju.\n# Potrebna predznanja\n* predznanje 1\n* predznanje 2\n* predznanje 3\n* ...\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n";


                    this.value = markupPresentation["wso2"];
                    this.input = markupPresentation["wso2"];
                } catch (err) {
                    alert(err);
                }
            },
            */
            whenOpened() {
                this.isLoading = false;
                // this.updateValue();
            },
            onCancel() {
                this.isLoading = false;
            },
            update: _.debounce(function (e) {
                this.input = e.target.value
            }, 300),
            updateValue: _.debounce(function (e) {
                this.input = e;
            }, 300)
        },
        computed: {
            compiledMarkdown: function () {
                return marked(this.input, {sanitize: true})
            }
        },
        mounted() {
        }

    }
</script>

<style lang="scss" scoped>
    .markdown-output {
        height: 100%;
        /*overflow-y: scroll;*/
        overflow-y: scroll;
        background-color: #f3f3f3;
    }


    markdown-editor {
        height: auto;
    }

    .vl {
        border-left: 1px dotted black;
        height: 100%;
    }

    /*.v-md-fullscreen {*/
    /*    width: 100%;*/
    /*    height: 100% !important;*/
    /*    top: 0;*/
    /*    left: 0;*/
    /*    right: 0;*/
    /*    bottom: 0;*/
    /*    position: fixed;*/
    /*    overflow: hidden;*/
    /*    z-index: 99999;*/
    /*}*/


    /*.v-md-fullscreen .v-md-preview {*/
    /*    position: fixed !important;*/
    /*    top: 52px;*/
    /*}*/
</style>
